import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { DEFAULT_TIME_ZONE, safeTimeZone } from "../../lib/dateTime.js";
import { useAuth } from "../auth/AuthProvider.jsx";
import { fetchProfile } from "./api.js";

const WorkspaceTimeZoneContext = createContext({
  timeZone: DEFAULT_TIME_ZONE,
  setTimeZone: () => {},
});

export function WorkspaceTimeZoneProvider({ children }) {
  const auth = useAuth();
  const [timeZone, setTimeZoneState] = useState(DEFAULT_TIME_ZONE);

  useEffect(() => {
    if (auth.status !== "authenticated") return undefined;
    let active = true;
    async function load() {
      try {
        const token = await auth.getIdToken();
        const profile = token ? await fetchProfile(token) : null;
        if (active && profile?.timezone) setTimeZoneState(safeTimeZone(profile.timezone));
      } catch {
        // The server-side thread still supplies the same default for Today.
      }
    }
    void load();
    return () => { active = false; };
  }, [auth]);

  const value = useMemo(() => ({
    timeZone,
    setTimeZone: (nextTimeZone) => setTimeZoneState(safeTimeZone(nextTimeZone)),
  }), [timeZone]);
  return <WorkspaceTimeZoneContext.Provider value={value}>{children}</WorkspaceTimeZoneContext.Provider>;
}

export function useWorkspaceTimeZone() {
  return useContext(WorkspaceTimeZoneContext);
}
